import { Modal } from 'antd';

import * as St from './SlabViewer.styles';

import { ColorModel } from '~/core/models';
import SlabViewerContent from '~organisms/SlabViewerContent';

interface SlabViewerProps {
  visible: boolean;
  previewColor: ColorModel;
  materialName: string;
  onCancel: () => void;
}

const SlabViewer = ({
  visible,
  previewColor,
  materialName,
  onCancel,
}: SlabViewerProps): JSX.Element => (
  <Modal
    className="SlabViewer"
    open={visible}
    onCancel={onCancel}
    width="auto"
    centered
    footer={null}
    closable
    destroyOnClose // Prevent previous slab image cache
  >
    <St.Title>{previewColor.name}</St.Title>
    <St.SubTitle>{materialName}</St.SubTitle>
    <SlabViewerContent
      previewColor={previewColor}
      materialName={materialName}
    />
  </Modal>
);

export default SlabViewer;
